import {calcUnitUpdateBasedOnPendingRecruitment} from "./calcUnitUpdateBasedOnPendingRecruitment";

export const calcRemainingSizeForRecruitment = (unit, maxSize, pendingRecruitmentActions) => {
  const pendingSize = calcUnitUpdateBasedOnPendingRecruitment(unit, pendingRecruitmentActions);
  const currentSize = unit.size + pendingSize;

  if(currentSize <= maxSize) {
    return maxSize - currentSize;
  }

  throw new Error(`[calcRemainingSizeForRecruitment]: Unit size exceeded: unitId=${unit.id}, currentSize=${currentSize}, maxSize=${maxSize}`)
}